<template>
  <div style="width: 800px;">
    <label style="font-weight: bold; font-size: 18px">
      Essential Skills
    </label>
    <br />
    <p>
      What are the top 5 essential skills do you have related to this area of
      interest?
    </p>

    <el-form @submit.native.prevent>
      <el-form-item :required="true">
        <div class="ts-comp--multiselect columned">
          <div
            v-for="(skill, index) in softSkills"
            :key="`softskill-${index}`"
            class="ts-comp--multiselect-item"
          >
            <label>
              {{ skill }}
            </label>
            <div class="cols">
              <span>
                <el-checkbox
                  @change="v => handleKnowledgeChange(skill, v)"
                  v-model="knowledgeRegularlyUsed[skill]"
                ></el-checkbox>
              </span>
            </div>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <el-alert
      v-if="essentialSkillsError"
      :title="essentialSkillsError"
      type="error"
      :closable="false"
    ></el-alert>
    <button
      class="ts-btn ts-btn-rounded ts-btn-secondary"
      @click="storeSection()"
    >
      Continue
    </button>
    <br />
    <a class="back-link" @click="goBack">
      <i class="fas fa-chevron-left"></i>Back
    </a>
    <br />
    <br />
    <br />
  </div>
</template>

<script>
export default {
  created() {
    this.fetchSession();

    if (
      this.currentCriteria.sgaMindset != null &&
      this.currentCriteria.sgaMindset.mindsets != undefined
    ) {
      this.sgaMindset = this.currentCriteria.sgaMindset;
    }

    this.$store.dispatch("onet/softSkills").then(result => {
      this.$store.dispatch(
        "sga/setSoftSkills",
        result.map(v => v.skill)
      );
    });
  },
  destroyed() {},
  data() {
    return {
      modelState: {},
      sgaMindset: {
        mindsets: []
      },
      essentialSkillsError: null
    };
  },
  watch: {},
  computed: {
    currentCriteria() {
      return this.$store.state.apprentice.current_apprentice_criteria;
    },
    softSkills() {
      return this.$store.state.sga.softSkills.sort((a, b) => (a > b ? 1 : -1));
    },
    knowledgeRegularlyUsed: {
      get() {
        return Object.assign(
          {},
          ...Object.entries({ ...this.softSkills }).map(an => {
            let oo = null;

            const fid = this.sgaMindset.mindsets.find(
              ms => ms.selection === an[1]
            );
            if (fid) oo = fid;
            try {
            } catch (error) {}

            return {
              [an[1]]: !!oo
            };
          })
        );
      },
      set(v) {}
    },
    currentMode() {
      return this.$store.state.sga.mode;
    }
  },
  methods: {
    fetchSession() {
      var parsed = JSON.parse(window.sessionStorage.getItem("currentCriteria"));
      if (parsed != null) {
        this.currentCriteria.id = parsed.id;
        this.currentCriteria.subjectArea = parsed.subjectArea;
        this.currentCriteria.level = parsed.level;
        this.currentCriteria.pathway = parsed.pathway;
        this.currentCriteria.sgaHiddenExtras =
          parsed.sgaHiddenExtras == null ? null : parsed.sgaHiddenExtras;
        this.currentCriteria.sgaKnowledge =
          parsed.sgaKnowledge == null ? null : parsed.sgaKnowledge;
        this.currentCriteria.sgaSkills =
          parsed.sgaSkills == null ? null : parsed.sgaSkills;
        this.currentCriteria.sgaMindset =
          parsed.sgaMindset == null ? null : parsed.sgaMindset;
      }
    },
    storeSection() {
      //client side validation, initial records should not save in DB
      if (this.sgaMindset.mindsets.length != 5) {
        this.essentialSkillsError = "Please select 5 items.";
        return false;
      } else {
        this.essentialSkillsError = null;
      }
      this.currentCriteria.sgaMindset = this.sgaMindset;
      window.sessionStorage.setItem(
        "currentCriteria",
        JSON.stringify(this.currentCriteria)
      );

      if (this.currentCriteria.id == null) {
        this.$store
          .dispatch(
            "apprentice/createuserinterestscriteria",
            this.currentCriteria
          )
          .then(() => {
            window.sessionStorage.removeItem("currentCriteria");
            this.$router.app.$emit("navigateToNextStep");
          })
          .catch(() => {
            this.$message.error(`${failedMessage} vacant role failed.`);
          })
          .finally(() => {
            this.isLoading = false;
          });
      } else {
        this.$store
          .dispatch(
            "apprentice/updateuserinterestscriteria",
            this.currentCriteria
          )
          .then(() => {
            window.sessionStorage.removeItem("currentCriteria");
            this.$router.app.$emit("navigateToNextStep");
          })
          .catch(() => {
            this.$message.error(`${failedMessage} vacant role failed.`);
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    goBack() {
      this.$router.back();
    },
    handleKnowledgeChange(obj, a) {
      let oo = null;

      try {
        const fid = this.sgaMindset.mindsets.findIndex(
          wpa => wpa.selection === obj
        );
        if (fid !== -1) oo = fid;
      } catch (error) {}

      if (oo == null) {
        this.sgaMindset.mindsets.push({
          selection: obj,
          Value: `IN`
        });
      } else {
        delete this.sgaMindset.mindsets[oo];
        this.sgaMindset.mindsets = this.sgaMindset.mindsets.filter(Boolean);
      }
    }
  }
};
</script>

<style lang="scss"></style>
